import { COLORS } from '../constants/colors';
import { LAYOUT } from '../constants/layout';
import { TYPOGRAPHY } from '../constants/typography';

export function applyDesignConstants() {
  const root = document.documentElement;

  root.style.setProperty('--page-padding-x', `${LAYOUT.pagePaddingX}px`);

  root.style.setProperty('--font-size-title', `${TYPOGRAPHY.title}px`);
  root.style.setProperty('--font-size-heading', `${TYPOGRAPHY.heading}px`);
  root.style.setProperty('--font-size-body', `${TYPOGRAPHY.body}px`);
  root.style.setProperty('--font-size-body-small', `${TYPOGRAPHY.bodySmall}px`);
  root.style.setProperty('--font-size-caption', `${TYPOGRAPHY.caption}px`);
  root.style.setProperty('--font-size-display', `${TYPOGRAPHY.display}px`);
  root.style.setProperty('--font-size-icon-large', `${TYPOGRAPHY.iconLarge}px`);
  root.style.setProperty('--font-size-icon', `${TYPOGRAPHY.icon}px`);

  root.style.setProperty('--color-text-primary', COLORS.textPrimary);
  root.style.setProperty('--color-text-accent', COLORS.textAccent);
  root.style.setProperty('--color-text-accent-light', COLORS.textAccentLight);

  root.style.setProperty('--color-bg-default', COLORS.bgDefault);
  root.style.setProperty('--color-bg-alt', COLORS.bgAlt);
  root.style.setProperty('--color-bg-accent', COLORS.bgAccent);
  root.style.setProperty('--color-photo-upload-bg', COLORS.photoUploadBg);
  root.style.setProperty('--color-photo-upload-text', COLORS.photoUploadText);
  root.style.setProperty('--color-photo-upload-button', COLORS.photoUploadButton);
  root.style.setProperty('--color-photo-upload-button-text', COLORS.photoUploadButtonText);

  root.style.setProperty('--color-accent-50', COLORS.accent50);
  root.style.setProperty('--color-accent-100', COLORS.accent100);
  root.style.setProperty('--color-accent-200', COLORS.accent200);
  root.style.setProperty('--color-accent-300', COLORS.accent300);
  root.style.setProperty('--color-accent-400', COLORS.accent400);
  root.style.setProperty('--color-accent-500', COLORS.accent500);
  root.style.setProperty('--color-accent-600', COLORS.accent600);

  root.style.setProperty('--color-border-primary', COLORS.borderPrimary);
  root.style.setProperty('--color-border-accent', COLORS.borderAccent);
  root.style.setProperty('--color-border-neutral', COLORS.borderNeutral);
  root.style.setProperty('--color-border-light', COLORS.borderLight);
  root.style.setProperty('--color-border-lighter', COLORS.borderLighter);

  root.style.setProperty('--color-line-muted', COLORS.lineMuted);
  root.style.setProperty('--color-line-accent', COLORS.lineAccent);
  root.style.setProperty('--color-heart-overlay', COLORS.heartOverlay);

  root.style.setProperty('--color-modal-bg', COLORS.modalBg);
  root.style.setProperty('--color-overlay', COLORS.overlay);
  root.style.setProperty('--color-copy-btn', COLORS.copyBtn);

  root.style.setProperty('--color-error', COLORS.error);
  root.style.setProperty('--color-groom', COLORS.groom);
  root.style.setProperty('--color-bride', COLORS.bride);
  root.style.setProperty('--color-text-muted', COLORS.textMuted);
  root.style.setProperty('--color-text-muted-dark', COLORS.textMutedDark);
}
